import axios from 'axios'

/**
 * Gets a single case. Bypasses Case store as fetchCases refreshes entire store which is not needed here. 
 */
async function getCase(caseId) {

  return new Promise((resolve, reject) => {

    if (!caseId) return reject(null);

    axios.get('/api/case/' + caseId)
      .then((res) => {
        return resolve(res.data)
      })
      .catch((error) => {
        reject(error);
      })
  })
}

async function getHistory(caseId) {
  return new Promise((resolve, reject) => {

    if (!caseId) return reject(null);

    axios.get('/api/history/' + caseId)
      .then((res) => {
        return resolve(res.data)
      })
      .catch((error) => {
        reject(error);
      })
  })
}

async function getCaseAndHistory(caseId) {
  return Promise.all([getCase(caseId), getHistory(caseId)]).then(function(data) {
    return {
        'case': data[0],
        'history': data[1]
    }
  });
}

function hasOpenCaseReports(caseRecord){
  var i = 0;
  if(caseRecord.caseReports){
    for(const caseReport of caseRecord.caseReports){
      if(caseReport.status === 'OPEN' || caseReport.status === "ESCALATED"){
        i++
      }
    }
  }
  return i;
}

export { getCase, getHistory, getCaseAndHistory, hasOpenCaseReports }